"use client"

import { signIn, useSession } from "next-auth/react";
import { redirect } from "next/navigation";
import Image from 'next/image'

import "./login.css"
import Button from "@/app/components/common/button/button";
import { useTheme } from "@/app/util/theme/themeProvider";

export default function Login() {
    const { theme } = useTheme();
    const isLight = theme === "light";    
    const logoSrc = isLight ? "/eda_logo_light_theme.png" : "/eda_logo_dark_theme.png"

    const { status } = useSession()
    if(status === "authenticated") {
        redirect("/")
    } else if (status === "loading") {
        return null
    } else {
        return (
            <div id="login-page">
                <div id="login-form">
                    <Image
                        src={logoSrc}
                        alt="everyday astronaut logo"
                        width={400}
                        height={96}
                    />
                    <Button onClick={() => signIn("discord", { callbackUrl: "/messages"})} width="100%" margin="10px 0 0 0">LOGIN WITH DISCORD</Button>
                </div>
                <div className="policy-buttons">
                    <a href="/policy/privacy" className="privacy-policy-button">Privacy Policy</a>
                    <a href="/policy/terms" className="privacy-policy-button">Terms</a>
                </div>
            </div>
        )
    }
}